const initialCapitalLetters = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1)
}

const formatImageUrl = (text: string) => {
  return `${text}?${performance.now()}`
}

export const StringUtils = { initialCapitalLetters, formatImageUrl }
